import { oauthResumePath } from "../auth/oauth-connector";
import { SignIn } from "./SignIn";

/**
 * `/oauth/sign-in` — where the auth Worker sends a signed-out visitor whose
 * MCP client (claude.ai, for the operator connector) is waiting on an
 * authorization. The console's own sign-in form, unchanged, with one
 * difference: on success it resumes THAT authorization — the signed query the
 * redirect carried, re-sent to the same-origin authorize endpoint, which then
 * finds the session cookie this sign-in just set and sends the admin on to
 * `/oauth/consent`. Outside the console gate (`console-routes.tsx`).
 *
 * Opened with no signed query (a bookmark, a stale tab), it is a plain console
 * sign-in that lands on the work queue.
 */
export function OAuthSignIn() {
  const resume = oauthResumePath(window.location.search);
  return (
    <SignIn
      destination={resume ?? "/"}
      subtitle={
        resume
          ? "Sign in with your admin account to connect Operator."
          : "Sign in with your staff account."
      }
    />
  );
}
